import React from 'react';
import { Link } from 'react-router-dom';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';

interface ICardCompanyTypeProps {
  icon: JSX.Element;
  title: string;
  description: string;
  linkButton: string;
}
function CardCompanyType({
  description,
  icon,
  linkButton,
  title,
  ...props
}: ICardCompanyTypeProps) {

  function onClickSubPage() {
    window.scrollTo({ top: 0 });
  }

  return (
    <S.Container {...props}>
      {icon}
      <S.AreaText>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
      </S.AreaText>
      <S.LinkArea>
        <Link to={linkButton} onClick={onClickSubPage}>
          <S.LinkText>
            {getTranslateByKey('information.learnMore')}
          </S.LinkText>
          <S.IconArrowRight />
        </Link>
      </S.LinkArea>
    </S.Container>
  )
}

export default CardCompanyType